import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

/**
 * Cliente del endpoint de B2C CLTV (spec 100 del backend).
 *
 * Igual que `cac-cltv.service.js`, el endpoint responde con el envelope
 * `{ data, meta }`: el éxito se determina por el código HTTP.
 */
export default class B2cCltvService {
  static getHeaders() {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${accessToken}` };
  }

  /**
   * CLTV, churn y CAC de B2C y B2B2C para un año, con el detalle del churn por
   * contrato.
   * @param {number} year - Año calendario, desde 2026.
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getMetrics(year) {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);

      const response = await axios.get(
        `${adminUrl}/b2c-cltv?${params.toString()}`,
        { headers: this.getHeaders() }
      );

      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error' };
    }
  }

  /**
   * Guarda el gasto anual de adquisición de cada línea.
   * @param {number} year - Año calendario.
   * @param {Array<{line: 'b2c'|'b2b2c', acquisitionCostUSD: number}>} parameters
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async saveParameters(year, parameters) {
    try {
      const body = {
        year,
        parameters: parameters.map((parameter) => ({
          line: parameter.line,
          acquisitionCostUSD: Number(parameter.acquisitionCostUSD)
        }))
      };

      const response = await axios.post(`${adminUrl}/b2c-cltv/parameters`, body, {
        headers: this.getHeaders()
      });

      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
